import React, { Component } from 'react';
import { connect } from 'react-redux';
import Link from 'gatsby-link';
import { Collapse, Nav, Navbar, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import LogoImg from '../assets/images/logo/gas-logo.svg';
import * as Scroll from 'react-scroll';

class NavigationBar extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
      isFixed: false,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll, { passive: true });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    this.setState({ giveNewClass: true });
  }

  handleScroll = () => {
    if (window.scrollY > 50) this.setState({ isFixed: true });
    else this.setState({ isFixed: false });
  };

  toggle() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  handleNavClicked = ref => {
    if (this.props.scrolling[this.props.slug][ref]) Scroll.animateScroll.scrollTo(this.props.scrolling[this.props.slug][ref]);
  };

  render() {
    return (
      <div className="container custom-container">
        <Navbar dark expand="lg" className={`responsive-nav pr-0 ${this.props.cls}`}>
          <div className="navbar-brand">
            <Link to={'/'}>
              <img className="navbar-brand-custom" src={LogoImg} alt="logo" />
            </Link>
          </div>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav navbar className="ml-auto">
              {this.props.navigations.map(e => {
                return (
                  <NavItem key={e.name}>
                    <NavLink className="txt-navigation" onClick={() => this.handleNavClicked(e.name)}>
                      {e.txt}
                    </NavLink>
                  </NavItem>
                );
              })}
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    );
  }
}

const mapStateToProps = store => ({
  scrolling: store.scrolling,
});

export default connect(mapStateToProps)(NavigationBar);



// WEBPACK FOOTER //
// ./src/components/NavigationBar.jsx